import React from 'react';

/**
 *
 *
 * Do not create arrow functions (e: UIEvent) => { e.preventDefault() } on every rerender in N components use this one.
 *
 * @param {Event} event - The React UI event to prevent default action in.
 * @returns {void} - This function does not return any value.
 *
 * @example
 * <Button onMouseDown={preventDefault}>Click me!</Button>
 */
export function preventDefault<T extends Event | React.UIEvent>(event: T): void {
  event.preventDefault();
}
